import { workAppontmentsAction } from "./workAppontments.action";

import { $api } from "../../../../services/request.config";

export const workAppontmentsThunkAction = () => async (dispatch) => {
    try {
        const allAppointments = await $api.get("v1/u/p/work/appointments");
        const temp = allAppointments.data.map((element) => {
            return {
                id: element.pid,
                name: `${element.position} ${element.firmName}`,
                position: element.position,
                firmName: element.firmName,
                structName: element.structName,
                isMain: element.isMain,
                tabNumber: element.tabNumber,
            };
        });
        dispatch(workAppontmentsAction(temp));
    } catch (e) {

    }
};
